import config from '../config';
import _ from 'lodash';
import CurrencyUtils from '../utils/CurrencyUtils';

const digitsOnly = new RegExp('^[0-9/.-]+$');

const NumberUtils = {
  /**
   * Append a currency by replacing a {} in string with the value given (and the currency sign on the front).
   * This function will also use toFixed to format the number.
   * @param  {string} string   string with {} to be replaced
   * @param  {number} value    the value to be formatted and added to string
   * @return {string} The resulting string after the replace.
   */
  appendCurrency(string, value, currencyCode = 'GBP', showCurrencySign = true) {
    if (_.isUndefined(value)) {
      return;
    }
    let { monetary_units } = CurrencyUtils[currencyCode] || {};
    if (_.isUndefined(monetary_units)) {
      monetary_units = config.currencyDecimals;
    }
    let currencySign =
      currencyCode === 'GBP' ? config.currencySign : currencyCode;
    if (!showCurrencySign) {
      currencySign = '';
    }
    const regEx = new RegExp(/\B(?=(\d{3})+(?!\d))/g);
    if (value < 0) {
      const amount = Math.abs(value)
        .toFixed(monetary_units)
        .replace(regEx, ',');
      if (currencyCode === 'GBP') {
        return string.replace('{}', `-${currencySign}${amount}`);
      }
      return string.replace('{}', `-${amount} ${currencySign}`);
    }
    const amount = parseFloat(value)
      .toFixed(monetary_units)
      .replace(regEx, ',');
    if (currencyCode === 'GBP') {
      return string.replace('{}', `${currencySign}${amount}`);
    }
    return string.replace('{}', `${amount} ${currencySign}`);
  },
  // Added to format Sort Code in XX-XX-XX
  formatSortCode(sortCode = '') {
    return sortCode !== null
      ? `${sortCode.slice(0, 2)}-${sortCode.slice(2, 4)}-${sortCode.slice(-2)}`
      : null;
  },

  formatCreditCard(creditcard) {
    return creditcard !== null
      ? `${creditcard.slice(0, 4)} ${creditcard.slice(4, 8)} ${creditcard.slice(
          8,
          12
        )} ${creditcard.slice(-4)}`
      : null;
  },

  formatAmount(amount) {
    if (amount) {
      return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return amount;
  },
  /**
   * convert the amont into comma seperator format
   * @param integer input: amount value
   * @param integer n: length of decimal
   * @param integer x: length of sections
   */
  decimalFormat(input, x, isShowCurrency = true) {
    const n = config.currencyDecimals;
    const num = parseFloat(input);
    const re = `\\d(?=(\\d{${x || 3}})+${n > 0 ? '\\.' : '$'})`;

    return (
      (isShowCurrency === true ? config.currencySign : '') +
      num.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,')
    );
  },
  isNumeric(input) {
    const isDigitsOnly = digitsOnly.test(input);
    const isNumeric = isDigitsOnly && !isNaN(input);

    return isNumeric;
  },
  isANumber(input) {
    const isDigitsOnly = digitsOnly.test(input);
    const isANumber = isDigitsOnly && !isNaN(input);

    return isANumber;
  },
};

export default NumberUtils;
